
export class Vendedor {
    id: number;
    idEmisor: string;
    nombres: string;
    cedula: string;
    telefono: string;
    estado: string;
    clave: string;
    
    }
    